<template>
  <div class="descriptionOfPack">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Packing_Information') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Carton_Seal') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaCartonseal"
          :otherData="{
            mediaName: '外箱封装方式',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCartonseal',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Front_Mark') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaFrontmark"
          :otherData="{
            mediaName: '外箱正唛',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaFrontmark',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Side_Mark') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaSidemark"
          :otherData="{
            mediaName: '外箱侧唛',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSidemark',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Carton_barcode') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaCartonbarcode"
          :otherData="{
            mediaName: '外箱条码',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCartonbarcode',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Carton_Size') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaCartonsize"
          :otherData="{
            mediaName: '外箱尺寸',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCartonsize',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Carton_Weight_Gross') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaCartonweight"
          :otherData="{
            mediaName: '外箱重量（带产品）',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCartonweight',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Inner_Packing') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaInnerpack"
          :otherData="{
            mediaName: '开箱后包装',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaInnerpack',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Corrugated_Layer') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaCartonlayer"
          :otherData="{
            mediaName: '外箱瓦楞质量',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCartonlayer',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Inner_box') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaInnerbox"
          :otherData="{
            mediaName: '内盒',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaInnerbox',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Packing_Details_Single_unit') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaPackdetail"
          :otherData="{
            mediaName: '单件产品包装方式',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaPackdetail',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{
        $tc('lang.LoadingReport.Others_Accessory_Manual_Polybag')
      }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.lmediaOther"
          :otherData="{
            mediaName: '其他',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaOther',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="[supervisionDetails]"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
// const columns = ;
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.ReportsDetail.CartonSize'),
          dataIndex: 'lreoprtCartonsize',
          key: 'lreoprtCartonsize',
        },
        {
          title: this.$tc('lang.ReportsDetail.CartonWeight'),
          dataIndex: 'lreoprtCartonweight',
          key: 'lreoprtCartonweight',
        },
        {
          title: this.$tc('lang.ReportsDetail.Unit_Packing_Detail'),
          dataIndex: 'lreoprtPackinfo',
          key: 'lreoprtPackinfo',
        },
        {
          title: this.$tc(
            'lang.ReportsDetail.Packing_Detail_For_Shipping_Carton',
          ),
          dataIndex: 'lreoprtPackway',
          key: 'lreoprtPackway',
        },
      ],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      id: this.$route.query.id,
    };
  },
  components: {
    showImg,
  },
  computed: {
    supervisionDetails: {
      get() {
        return this.$store.state.report.supervisionDetails;
      },
      set(val) {
        this.$store.commit('report/save', { supervisionDetails: val });
      },
    },
    descriptionOfPack: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.supervisionImgList.descriptionOfPack,
          ),
        );
      },
    },
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-loadigreport/getData', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.supervisionDetails = data;
          } else {
            this.supervisionDetails = {};
          }
        })
        .catch(() => {
          this.supervisionDetails = {};
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfPack {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
